@if (hasBackground) {
    <div
        class="sb-tab-group-header-background"
        [class.sb-tab-header-vertical]="orientation === Orientation.Vertical">
        <ng-container *ngTemplateOutlet="tapGroupHeader"></ng-container>
    </div>
} @else {
    <ng-container *ngTemplateOutlet="tapGroupHeader"></ng-container>
}
<ng-template #tapGroupHeader>
    <div
        id="tab-group-top-element"
        #topElement
        [style.--mat-tab-animation-duration]="animationDuration"
        [ngClass]="{
            'position-sticky': stickyHeader,
            'sb-tab-small': size === TabSize.Small,
            'sb-tab-medium': size === TabSize.Medium,
            'sb-tab-large': size === TabSize.Large,
            'sb-tab-header-vertical sb-tab-vertical': orientation === Orientation.Vertical
        }">
        @if (orientation === Orientation.Vertical) {
            <span
                class="sb-tab-vertical-indicator"
                [style.transform]="'translateY(' + selectedIndicatorOffset + ')'"></span>
        }
        <div class="sb-tab-header-wrapper" [class.padding-x-8]="canScrollRight || canScrollLeft">
            @if (!isTouchScreenDevice && (canScrollRight || canScrollLeft)) {
                <lib-icon-button
                    [icon]="Icon.Common.ChevronLeft"
                    [disabled]="!canScrollLeft"
                    [kind]="ButtonKind.NeutralTertiary"
                    (clicked)="ScrollTabsLeft()"></lib-icon-button>
            }
            <mat-tab-group
                #header
                class="sb-tab-header"
                [disableRipple]="true"
                [animationDuration]="animationDuration"
                [selectedIndex]="selectedIndex"
                (selectedIndexChange)="SelectedIndexChangeEvent($event)"
                (animationDone)="AnimationDone()">
                @for (tab of bodyComponent.tabComponentQueryList; track tab) {
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <!-- manually wrap the qaTag around the label -->
                            <div [attr.data-sb-qa]="tab.name + '-tab-label'">
                                {{ tab.label }}
                            </div>
                            @let form = GetTabForm(tab);
                            @if (form?.isDirty || form?.errorCount) {
                                <lib-badge class="position-absolute"
                                    [style.top.px]="8"
                                    [style.left.%]="100"
                                    [style.margin-left.px]="-8"
                                    [kind]="form!.errorCount ? BadgeKind.Count : BadgeKind.Dot"
                                    [color]="form!.errorCount ? BadgeColor.Attention : BadgeColor.Brand"
                                    [text]="form!.errorCount"></lib-badge>
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
            @if (!isTouchScreenDevice && (canScrollRight || canScrollLeft)) {
                <lib-icon-button
                    [icon]="Icon.Common.ChevronRight"
                    [kind]="ButtonKind.NeutralTertiary"
                    [disabled]="!canScrollRight"
                    (clicked)="ScrollTabsRight()"></lib-icon-button>
            }
        </div>
        <div
            #addToHeader
            [hidden]="addToHeader.children.length == 0"
            class="align-self-center">
            <ng-content select="[addToHeader]"></ng-content>
        </div>
    </div>
</ng-template>
